import { TaskRawStateEnum } from "../../annualWheel/AnnualWheel.types";
import { AnnualWheelActivityGeneralType } from "../../annualWheel/annualWheelDialog/AnnualWheelDialog.types";
import { EvaluationStatus } from "../../common/components/questionnaireComponents/evaluateQuestionnaireDialog/EvaluateQuestionnaireDialog.types.ts";

export interface TaskViewModel {
    id: string;
    name: string;
    processingActivityName: string;
    description: string;
    deadline: Date;
    deadlineMaxDate: Date | null;
    taskState: TaskRawStateEnum;
    isOverdue: boolean;
    isProcessingActivityValidation: boolean;
    processingActivityId: string | null;
    annualWheelActivityId?: string;
    documentationRequired: boolean;
    hasDocument: boolean;
    isAdHocTask: boolean;
    legalEntityName: string | null;
    customId: string | null;
    notPartOfCurrentPlan: boolean;
    annualWheelActivityGeneralType?: AnnualWheelActivityGeneralType | null;
    contractId?: string;
    riskMitigationPlanId?: string | null;
    evaluationStatus?: EvaluationStatus;
    evaluation?: string;
    evaluatedTask?: EvaluatedTaskViewModel;
    isEvaluationTask: boolean;
}

export interface EvaluatedTaskViewModel {
    id: string;
    name: string;
    evaluationStatus?: EvaluationStatus;
    evaluation?: string;
}

export interface AnnualWheelActivityTaskNavigationViewModel {
    previousTaskId: string | null;
    previousDeadline: string | null;
    nextTaskId: string | null;
    nextDeadline: string | null;
    position: number;
    total: number;
}

export interface TaskSaveModel {
    title: string;
    description: string;
}

export interface TaskEvaluationSaveModel {
    evaluation?: string;
    evaluationStatus?: EvaluationStatus;
}

export enum AddTaskClickEnum {
    None = 0,
    ShowSection = 1,
    ShowFileExplorer = 2,
}

export enum AddRelatedTaskScenario {
    None = 0,
    ShowContent = 1,
    ShowContentAndOpenSuggenstions = 2,
}
